
const Section = (props) =>{  
  return(
    <div 
      id={props.id?props.id:""} 
      className="block-full bg-section-1 py-48 sm:py-64 lg:py-96 px-16 sm:px-24"
    >
      <div className="block-full max-w-1200 mx-auto text-center">
        {props.children}
      </div>
    </div>
  )
}

const Section2 = (props) =>{  
  return(
    <div 
      id={props.id?props.id:""} 
      className="block-full bg-section-2 py-48 sm:py-64 lg:py-96 px-16 sm:px-24"
    >
      <div className="block-full max-w-1200 mx-auto text-center">
        {props.children}
      </div>
    </div>
  )
}

const SectionTitle = ({title,ts}) =>{  
  return(
    <div className="block-full">
      <div className={`gradient-text-${ts || 1}f inline max-w-full  font-inter fw-700 fs-30 lh-36 md:fs-36 md:lh-40 lg:fs-40 lg:lh-48 mx-auto`}>
        {title}
      </div>
      <div className={`block-80 sm:w-100 lg:w-150 h-4 gradient-bc-${ts || 1}f br-2 mx-auto mt-8`}/>
    </div>
  )
}

const SectionTitle2 = ({title,ts}) =>{  
  return(
    <div className="block-full">
      <div className={`gradient-text-${ts || 1} inline max-w-full font-inter fw-600 fs-24 lh-30 lg:fs-30 lg:lh-36 mx-auto`}>
        {title}
      </div>
      <div className={`block-44 sm:w-60 lg:w-80 h-4 gradient-bc-${ts || 1} br-2 mx-auto mt-4`}/>
    </div>
  )
}

const SectionDesc = ({value}) =>{  
  return(
    <div className="block-full max-w-768 font-inter fw-400 fs-14 sm:fs-16 lh-20 mt-12 mx-auto color-soft text-center">
        {value}
    </div>
  )
}

const SectionDesc2 = ({value}) =>{  
  return(
    <div className="block-full max-w-768 font-inter fw-400 fs-14 sm:fs-16 lh-20 mt-12 mx-auto color-soft text-center">
        {value}
    </div>
  )
}

const Card = (props) =>{  
  return(
    <div 
      className="block-full bg-surface-1 p-16 sm:p-24 lg:p-32 br-12 shadow-md hover:shadow-lg transition-medium cursor-pointer"
      onClick={props?.onClick}  
    >
      {props.children}
    </div>
  )
}

const Card2 = (props) =>{  
  return(
    <div 
      className="block-full h-full bg-surface-1 p-16 sm:p-24 lg:p-32 br-12 bw-2 bw-t-8 bs-solid bc-highlight-2 cursor-pointer"
      onClick={props?.onClick}  
    >
      {props.children}
    </div>
  )
}

const SliderCard1 = (props) =>{  
  return(
    <div 
      className={`block-full h-full br-12 cursor-pointer p-2 overflow-hidden ${props?.className??""}`}
      onClick={props?.onClick}  
    >
      <div className="block-full h-full p-16 sm:p-24 lg:p-32 bg-surface-1 br-10">
        {props.children}
      </div>
      
    </div>
  )
}

const GradCard1 = (props) =>{  
  return(
    <div 
      className={`block-full br-12 cursor-pointer p-2 shadow-md hover:shadow-lg transition-medium zoom-4  ${props?.className??""}`}
      onClick={props?.onClick}  
    >
      <div className="block-full h-full p-16 sm:p-24 lg:p-32 bg-surface-1 br-10">
        {props.children}
      </div>
      
    </div>
  )
}
const GradCard2 = (props) =>{  
  return(
    <div 
      className={`block-full br-12 cursor-pointer p-2 shadow-md hover:shadow-lg transition-medium zoom-4  ${props?.className??""}`}
      onClick={props?.onClick}  
    >
      <div className="block-full h-full p-20 md:p-24 lg:p-32 bg-surface-1 br-10">
        {props.children}
      </div>
      
    </div>
  )
}



export {
  Section,Section2,
  SectionTitle,
  SectionTitle2,
  SectionDesc,
  SectionDesc2,
  Card,
  Card2,

  SliderCard1,
  GradCard1,
  GradCard2
}
